import React, { useEffect } from 'react'
import i18n from '../i18n';
import { useDispatch, useSelector } from 'react-redux';
import { switchLanguage } from '../features/translation-slice';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

// compact: a globe-icon pill with no visible label, for page headers.
const LanguageSwitcher: React.FC<{className?: string, containerClassName?: string, compact?: boolean}> = ({className, containerClassName, compact}) => {
    const dispatch = useDispatch();
    const currentLanguage = useSelector((state: any) => state.traslation.language);
    const { t } = useTranslation();
    useEffect(() => {
        i18n.changeLanguage(currentLanguage as ('fr' | 'en' | 'pt'));
    },[]);

    const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedLanguage = e.target.value;
        dispatch(switchLanguage(selectedLanguage));
        i18n.changeLanguage(selectedLanguage as ('fr' | 'en' | 'pt'));
    };
    if (compact) {
        return (
            <label className={`${containerClassName || ''} flex items-center gap-2 border border-gray-300 rounded-full pl-4 pr-2 py-2 bg-white`}>
                <Globe className='w-5 h-5 text-gray-700 shrink-0' aria-hidden />
                <span className='sr-only'>{t('select-language')}</span>
                <select
                    value={currentLanguage}
                    onChange={handleLanguageChange}
                    className={`${className || ''} bg-transparent pr-1 text-sm text-gray-900 focus:outline-none cursor-pointer`}
                >
                    <option value="en">English</option>
                    <option value="fr">French</option>
                    <option value="pt">Portuguese</option>
                </select>
            </label>
        )
    }
    return (
        <div className={`${containerClassName || 'flex items-center justify-center'}`}>
            <label className='mr-3 font-sans'>{t('select-language')}</label>
            <select
                value={currentLanguage}
                onChange={handleLanguageChange}
                className={`${className} border border-slate-300 mr-5 py-3 px-3 rounded-xl focus:border-slate-300 focus:outline-none`}
            >
                <option value="en">English</option>
                <option value="fr">French</option>
                <option value="pt">Portuguese</option>
            </select>
        </div>
    )
}

export default LanguageSwitcher